import { useState } from "react";


export const usePostCsvExcelAccountsStates = () => {
  const [isActiveRegisterButton, setIsActiveRegisterButton] = useState(false);
  const [passbookName, setPassbookName] = useState("");

  return {
    isActiveRegisterButton,
    setIsActiveRegisterButton,
    passbookName,
    setPassbookName,
  };
};
